import {AlternativeAutoComplete} from 'common/form/autoComplete/_alternativeAutoComplete'
import {Option} from 'common/form/autoComplete/_option'
import useOrderFilterForm from 'Pages/orderBook/hooks/useOrderFilterForm'
import React from 'react'

export const CustomerType = () => {
  const {customerType} = useOrderFilterForm()

  return (
    <AlternativeAutoComplete
      className="order-filter-form__input-wide"
      // main input
      inputProps={{
        categoryList: [], // menu list in category dropdown
        categoryValue: {name: 'Loại khách hàng', value: ''}, // if not exist this value -> default category: categoryList[0]
        categoryWidth: 120,
        placeholder: 'Chọn loại khách hàng',
        readOnly: true,
        value: customerType.value?.name || '',
        onIconClick: () => customerType.onChange(null),
      }}
      // menu
      menuProps={{
        empty: customerType.list.length <= 0 ? 'Không tìm thấy loại khách hàng' : '',
      }}
      // search input in dropdown menu
      searchInputProps={{
        placeholder: 'Tìm kiếm loại khách hàng',
        value: customerType.keyword,
        onChange: customerType.onKeywordChange,
      }}
      hideSearchBar={true}
    >
      {customerType.list.length > 0 &&
        customerType.list.map(item => (
          <Option
            key={item.value}
            className="order-filter-form__option-text"
            data-active={item.value === customerType.value?.value}
            onClick={() => customerType.onChange(item)}
          >
            {item.name}
          </Option>
        ))}
    </AlternativeAutoComplete>
  )
}
